import React from 'react';
import './App.css';
import MessagesList from './containers/MessagesList';
import { AddMessage } from './containers/AddMessage';
import { AppointmentForm } from './containers/AppointmentForm';
import { ErrorMessage } from './containers/ErrorMessage';
import queryString from 'query-string';

// Import App2.css when option2 is active
const { option } = queryString.parse(window.location.search);
if (option !== undefined) {
  require('./App2.css');
}

function App() {
  return (
    <div className="App">
      <div className="chat-box">
        <MessagesList />
        <AddMessage />
      </div>
      <AppointmentForm />
      <ErrorMessage />
    </div>
  );
}

export default App;